import '../../instrument.js';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@repo/themes/styled-system/styles.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initTeams } from './teams';
import { TEAMS_SESSION_ID } from '@/shared/lib/constants';
import * as Sentry from '@sentry/react';
import { RouterProvider } from 'react-router/dom';
import { AuthProvider } from '@/providers/AuthContext.js';
import { router } from './router';

const queryClient = new QueryClient();

async function enableMocking() {
  if (import.meta.env.MODE !== 'test') {
    return;
  }
  const { worker } = await import('../testing/mocks/browser');
  return worker.start();
}
initTeams()
  .then(() => {
    sessionStorage.setItem(TEAMS_SESSION_ID, 'true');
  })
  .catch(() => {
    // Expected to fail when not running inside Microsoft Teams
  })
  .finally(() => {
    enableMocking().then(() => {
      createRoot(document.getElementById('root')!, {
        // Callback called when an error is thrown and not caught by an ErrorBoundary.
        onUncaughtError: Sentry.reactErrorHandler(),
        // Callback called when React catches an error in an ErrorBoundary.
        onCaughtError: Sentry.reactErrorHandler(),
        // Callback called when React automatically recovers from errors.
        onRecoverableError: Sentry.reactErrorHandler(),
      }).render(
        <StrictMode>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <RouterProvider router={router} />
            </AuthProvider>
          </QueryClientProvider>
        </StrictMode>,
      );
    });
  });
